module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-semibold-fdf56b22f9fbdf2f583fae9bf1f6a2a1.woff";